"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollLock = void 0;
var react_1 = require("react");
var useIsomorphicLayoutEffect_1 = require("@r1-frontend/shared/hooks/useIsomorphicLayoutEffect");
// @todo this effect must be used in the true Popup Component (we should implement absolutely effective Popup Component in @r1-frontend/ui-react)
var useScrollLock = function () {
    var lockScroll = (0, react_1.useCallback)(function () {
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = 'var(--scrollbar-compensation)';
        document.body.dataset.scrollLock = 'true';
    }, []);
    var unlockScroll = (0, react_1.useCallback)(function () {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        delete document.body.dataset.scrollLock;
    }, []);
    (0, useIsomorphicLayoutEffect_1.useIsomorphicLayoutEffect)(function () {
        // calculation the width of scrollbar
        var scrollBarCompensation = window.innerWidth - document.body.offsetWidth;
        document.body.style.setProperty('--scrollbar-compensation', "".concat(scrollBarCompensation, "px"));
    }, []);
    return {
        lockScroll: lockScroll,
        unlockScroll: unlockScroll,
    };
};
exports.useScrollLock = useScrollLock;
exports.default = exports.useScrollLock;
